import {createApp} from 'vue'
import {createPinia, Pinia} from 'pinia'
import App from './App.vue';
import {useStore} from "./store";
import {PageData} from "./services/content";
import Follow from "../../shared/components/follow";
import {hasCookie} from "../../lib/utils/cookies";
import * as Sentry from "@sentry/vue";
// import {addListener} from "../../shared/interaction-listener";

export const initApp = ():void => {
    const pageData = parsePage();

    const pinia = createPinia()
    const app = createApp(App);

    app.use(pinia);

    const store = useStore()
    store.setInitialItemData(pageData)
    Sentry.addIntegration(Sentry.vueIntegration({ app }));
    app.mount('#player-holder');

    attachListeners(pinia);
    hydrate()

    // const posterEl = document.querySelector<HTMLElement>("#event-poster")
    // if (posterEl){
    //     posterEl.addEventListener("click", function (e) {
    //         e.preventDefault();
    //         store.setClicked()
    //     })
    // }
}

function hydrate(){
    if (!hasCookie('eid', document.cookie)){
        return;
    }
    let votes: {[key: number]: number} | null = null;
    try {
        const data = localStorage.getItem('tsd.vote');
        if (data){
            votes = JSON.parse(data)
        }
    }catch (e){
        //e
    }
    if (!votes){
        return;
    }


    document.querySelectorAll<HTMLButtonElement>('button.match-vote').forEach((el: HTMLButtonElement) => {
        if (!el.dataset.matchId)
            return;
        const matchId = parseInt(el.dataset.matchId);
        if (votes && votes[matchId]){
            el.classList.add('border','border-mono-ps-200')
            el.classList.remove('cursor-pointer', 'bg-mono-ns-200', 'hover:bg-mono-ns-300')
            el.disabled = true
        }
    })
}

function parsePage(): PageData {
    const data: PageData = {
        id: 0,
        item_id: "",
        main_item_id: "",
        title: "",
    }

    const titleEl = document.querySelector<HTMLElement>(`#event-title`)
    if (titleEl){
        data.title = titleEl.innerText
    }

    const eventInfoEl = document.querySelector<HTMLElement>(`#event-details`);
    if (eventInfoEl && eventInfoEl.dataset.vid){
        data.main_item_id = eventInfoEl.dataset.vid
        data.item_id = eventInfoEl.dataset.vid
    }
    if (eventInfoEl && eventInfoEl.dataset.vvid){
        data.id = parseInt(eventInfoEl.dataset.vvid)
    }

    const eventImageEl = document.querySelector<HTMLElement>(`#event-image`)
    if (eventImageEl){
        const img = []
        for(let i = 0; i < eventImageEl.children.length; i++){
            if (eventImageEl.children[i].tagName === "SOURCE"){
                const row: HTMLSourceElement = eventImageEl.children[i] as HTMLSourceElement
                img.push({
                    tagName: row.tagName,
                    media: row.media,
                    type: row.type,
                    sizes: row.sizes,
                    srcset: row.srcset
                })
            }else{
                const row: HTMLImageElement = eventImageEl.children[i] as HTMLImageElement
                img.push({
                    tagName: row.tagName,
                    sizes: row.sizes,
                    srcset: row.srcset,
                    width: row.width,
                    height: row.height
                })
            }
        }
        data.featuredImage = img
    }

    const eventBroadcastEl = document.querySelector<HTMLElement>(`#event-broadcast`)
    if (eventBroadcastEl && eventBroadcastEl.dataset.airStart && eventBroadcastEl.dataset.airEnd){
        data.broadcasts = [
            {
                is_live: true,
                air_start_time: eventBroadcastEl.dataset.airStart,
                air_end_time: eventBroadcastEl.dataset.airEnd,
            }
        ]
    }
    try {
        const rawData = localStorage.getItem('fite.alt')
        let alternatives = null;
        if (rawData){
            alternatives = JSON.parse(rawData)
        }
        if (alternatives && alternatives.data && Object.prototype.hasOwnProperty.call(alternatives.data, data.item_id)){
            const altLang = alternatives.data[data.item_id].lang || null;
            if (altLang){
                const el = document.querySelector<HTMLElement>(`li[data-lang="${altLang}"]`)
                if (el && el.dataset.altId && el.dataset.altVvid){
                    data.item_id = el.dataset.altId
                    data.id = parseInt(el.dataset.altVvid)
                    const markerSGV: HTMLElement | null = document.querySelector<HTMLElement>('.alternative-languages .checked');
                    const label = el.querySelector("span");
                    if (markerSGV && label){
                        el.insertBefore(markerSGV, label)
                    }
                }
            }
        }
        // eslint-disable-next-line no-empty
    }catch (e){}

    return data
}

// function initPushNotifications(){
//     console.log("initPushNotifications")
//     if(navigator.serviceWorker !== undefined && !/^((?!chrome|android).)*safari/i.test(navigator.userAgent)){
//         console.log("push notifications")
//         import(/* webpackChunkName: "triller-push" */ './firebase-push')
//             .then((module) => {
//                 module.initApp("test")
//             })
//     }
// }

function attachListeners(pinia: Pinia) {

    document.querySelectorAll<HTMLElement>('li[data-alt-id]').forEach((el: HTMLElement) => {
        el.addEventListener('click', function (this: HTMLElement, event: MouseEvent) {
            const store = useStore(pinia)
            event.preventDefault()
            if (this.dataset && this.dataset.altId && this.dataset.altId !== store.itemId){
                const markerSGV: HTMLElement | null = document.querySelector<HTMLElement>('.alternative-languages .checked');
                const label = this.querySelector("span");
                if (markerSGV && label){
                    this.insertBefore(markerSGV, label)
                }
                // TODO: refactor this
                store.switchItem(this.dataset.altId)
                    .then(() => {
                        //console.log("switched")
                    })
            }
        })
    })

    document.querySelectorAll<HTMLButtonElement>('button[data-toggle="share"]').forEach((el: HTMLButtonElement) => {
        el.addEventListener('click', () => {
            const store = useStore(pinia)
            store.toggleModal('share')
        })
    })

    document.querySelector<HTMLButtonElement>('button[data-toggle="rate"]')?.addEventListener("click", () => {
        const store = useStore(pinia)
        store.toggleModal('rate')
    })

    document.querySelectorAll<HTMLButtonElement>('button.match-vote')?.forEach((el: HTMLButtonElement) => {
        el.addEventListener('click', (e) => {
            const store = useStore(pinia)
            const el = e.target as HTMLButtonElement
            if (!el)
                return;

            if (!hasCookie('eid', document.cookie)){
                store.toggleModal('sign-in')
                return
            }

            const matchId = el.dataset.matchId
            const fighterId = el.dataset.fighterId
            if (!matchId || !fighterId){
                return;
            }

            document.querySelectorAll<HTMLButtonElement>(`button[data-match-id="${matchId}"]`)
                .forEach((row) => {
                    row.disabled = true
                })

            store.vote(parseInt(matchId), parseInt(fighterId))
                .then(() => {
                    document.querySelectorAll<HTMLButtonElement>(`button[data-match-id="${matchId}"]`)
                        .forEach((row) => {
                            row.classList.add('border','border-mono-ps-200')
                            row.classList.remove('cursor-pointer', 'bg-mono-ns-200', 'hover:bg-mono-ns-300')
                            row.disabled = true
                        })
                }).catch((error: Response) => {
                    document.querySelectorAll<HTMLButtonElement>(`button[data-match-id="${matchId}"]`)
                        .forEach((row) => {
                            if (error.status === 409){
                                row.classList.add('border','border-mono-ps-200')
                                row.classList.remove('cursor-pointer', 'bg-mono-ns-200', 'hover:bg-mono-ns-300')
                                row.disabled = true
                            }else{
                                row.disabled = false
                            }
                        })
                })
            document.querySelector<HTMLElement>("body")?.dispatchEvent(new CustomEvent(
                'notify',
                {
                    bubbles: true,
                    detail: { message: "Thank you for voting!", type: "success"}
                }))

        })
    })

    document.querySelectorAll<HTMLButtonElement>('button.bookmark').forEach((el: HTMLButtonElement) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const store = useStore(pinia)
            if (!hasCookie('eid', document.cookie)){
                store.toggleModal('sign-in')
                return
            }
            const bookmarked = store.isBookmarked()
            let message = "Added to Watch Later!"
            if (bookmarked){
                message = "Removed from Watch Later!"
            }
            (e.target as HTMLButtonElement).disabled = true;
            store.bookmarkItem(store.itemId, !bookmarked)
                .then(() => {
                    window.postMessage({e: "watch-later", state: !bookmarked});
                    (e.target as HTMLButtonElement).disabled = false;
                })
            document.querySelector<HTMLElement>("body")?.dispatchEvent(new CustomEvent(
                'notify',
                {
                    bubbles: true,
                    detail: { message: message, type: "success"}
                }))
        })
    })

    document.querySelector<HTMLElement>('#player-holder')?.addEventListener('switch-screen', function (e: CustomEvent){
        if(e.detail?.visible){
            document.querySelector<HTMLElement>('#event-title')?.classList.remove("hidden");
            document.querySelector('#event-details [data-toggle="rate"]')?.classList.remove("hidden");
        }else{
            document.querySelector<HTMLElement>('#event-title')?.classList.add("hidden");
            document.querySelector('#event-details [data-toggle="rate"]')?.classList.add("hidden");
        }

    } as EventListener)

    window.addEventListener("message", (message) => {
        if (message.origin === window.location.origin){
            if (message?.data?.e === "reload"){
                const store = useStore(pinia)
                // reload item info if not currently playing
                if (store.page !== "player"){
                    store.detailsScreen()
                    store.toggleBackdrop(false)
                    void store.fetchContentItem(store.itemId)
                }
            }else if(message?.data?.e === "language-switch"){
                const el = document.querySelector<HTMLElement>(`li[data-lang="${message.data.lang}"]`)
                if (el){
                    const markerSGV: HTMLElement | null = document.querySelector<HTMLElement>('.alternative-languages .checked');
                    const label = el.querySelector("span");
                    if (markerSGV && label){
                        el.insertBefore(markerSGV, label)
                    }
                }
                const store = useStore(pinia);
                const elDesc = document.querySelector<HTMLElement>(".event-description");
                if (elDesc){
                    elDesc.innerHTML = store.description
                }
                const elTitle = document.querySelector<HTMLElement>(`#event-title`);
                if (elTitle){
                    elTitle.innerHTML = store.title
                }
            }else if (message?.data?.e === "watch-later" && message?.data?.state !== undefined){
                document.querySelectorAll<HTMLButtonElement>('.bookmark').forEach((el: HTMLButtonElement) => {
                    let icon = "#icon-clock"
                    if (message?.data?.state === true){
                        icon = "#icon-clock-full"
                    }
                    el.querySelector<SVGUseElement>('svg use')?.setAttribute('xlink:href', icon)
                })

            }else if (message?.data?.e === "chat-leave"){
                useStore(pinia).toggleChat()
            }
        }
    })

    // addListener(initPushNotifications)

    new Follow()
}

export default initApp
